import { defineMessages } from 'react-intl';

export default defineMessages({
  affirmPrefix: {
    id: 'AffirmAsLowAs.affirmPrefix',
    description: 'Affirm prefix',
    defaultMessage: 'As low as',
  },
  affirmSuffix: {
    id: 'AffirmAsLowAs.affirmSuffix',
    description: 'Affirm suffix',
    defaultMessage: 'with {affirmLogo}',
  },
  affirmLogoAlt: {
    id: 'AffirmAsLowAs.affirmLogoAlt',
    description: 'Affirm logo alt',
    defaultMessage: 'Affirm financing logo',
  },
});
